const ITEM_FIELDS = ["name", "order_number", "img", "date", "date_delta", "ua", "meter"];

export function normalizeItemDateForApi(dateValue) {
    if (dateValue === "0" || dateValue === 0) {
        return null;
    }
    if (dateValue === "" || dateValue === null || dateValue === undefined) {
        return dateValue;
    }
    const parts = String(dateValue).split("-");
    if (parts.length !== 3) {
        return dateValue;
    }
    const [day, month, year] = parts;
    return `${year}-${month}-${day}`;
}

export function getItemChanges(item, originalItem) {
    const changes = [];
    ITEM_FIELDS.forEach((key) => {
        if (!Object.prototype.hasOwnProperty.call(item, key)) {
            return;
        }
        if (!originalItem || originalItem[key] !== item[key]) {
            const value = key === "date" ? normalizeItemDateForApi(item[key]) : item[key];
            changes.push({ key, value });
        }
    });
    return changes;
}

export function mapDatabaseItems(data) {
    const fixedData = {};
    data.forEach((item) => {
        item.new_date = item.date;
        if (item.ua != 1) {
            fixedData[item.id] = item;
        }
    });
    return fixedData;
}

export function buildProcessedMeters(correctOrder, dataMap, filterItem) {
    if (!correctOrder || !dataMap) {
        return [];
    }
    const processedData = [];
    correctOrder.forEach((meter, index) => {
        const items = [];
        meter.forEach((itemId) => {
            const item = dataMap[itemId];
            if (!item) {
                return;
            }
            if (!filterItem || filterItem(item)) {
                items.push(item);
            }
        });
        processedData[index] = items;
    });
    return processedData;
}
